import { AuctionAQueryRepository } from '@/Domain/AuctionA'
import store from '@/Infrastructure/Store'

export class VuexAuctionAQueryRepository implements AuctionAQueryRepository {
  readAuctionAData (): string {
    const auctionData = { ...store.getters['auction/fullStatus'] }
    const currentProcedure = store.getters['procedure/currentProcedure']
    auctionData.currentProcedure = currentProcedure.toJSON()
    return JSON.stringify(auctionData)
  }
}
